import { LAYOUTS } from "@voltmoney/types";
import { WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../../routes";
import { ACTION } from "./types";
import { goBack } from "./action";
import { api } from "../../../configs/api";
import SharedPropsService from "../../../SharedPropsService";
import { getAppHeader } from "../../../configs/config";
import { getContactUsDetails } from "../../../configs/utils";
export const template = (height, getLoanDetails, contactUsDetails) => {
    return {
        layout: {
            id: ROUTE.MY_LOAN_PROFILE,
            type: LAYOUTS.LIST,
            style: {
                isPartnerPlatform: true
            },
            widgets: [
                {
                    id: 'myLoanProfile', type: WIDGET.MY_LOAN_PROFILE,
                },
            ],
        },
        datastore: {
            myLoanProfile: {
                height,
                getLoanDetails,
                contactUsDetails,
                backAction: {
                    type: ACTION.GO_BACK,
                    payload: {},
                    routeId: ROUTE.MY_LOAN_PROFILE,
                },
            }
        },
    };
};
export const myLoanDetailsMf = {
    onLoad: async ({ getHeight, network }) => {
        const user = await SharedPropsService.getUser();
        const creditId = user?.linkedCredits[0]?.creditId;
        const contactUsDetails = await getContactUsDetails();
        const getLoanDetails = await network.get(`${api.getLoanDetails}${creditId}`, { headers: await getAppHeader() });
        return Promise.resolve(template(getHeight(), getLoanDetails, contactUsDetails));
    },
    actions: {
        [ACTION.GO_BACK]: goBack,
    },
};
